import { useEffect, useState } from "react"

function Addresses(){

const [address,setAddress] = useState(null)

useEffect(()=>{

const saved = localStorage.getItem("userAddress")

if(saved){
setAddress(JSON.parse(saved))
}

},[])

return(

<div style={{padding:"40px"}}>

<h2>My Addresses</h2>

{address ? (

<div className="addressCard">

<p><b>{address.name}</b></p>

<p>{address.fullAddress}</p>

<p>{address.city} - {address.pincode}</p>

<p>{address.phone}</p>

</div>

):( 

<p>No address saved</p>

)}

</div>

)

}

export default Addresses